export const convertToLocalDate=(utcString)=> {
    // Replace any dashes with slashes to handle both formats
    const utcStringFormatted = utcString.replace(/-/g, '/');
 
    // Create a Date object from the UTC string
    const utcDate = new Date(utcStringFormatted + ' UTC');
 
    // Get the local time components
    const localDate = new Date(utcDate);
 
    const year = localDate.getFullYear();
    const month = (localDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const day = localDate.getDate().toString().padStart(2, '0');
    const hours = localDate.getHours().toString().padStart(2, '0');
    const minutes = localDate.getMinutes().toString().padStart(2, '0');
    const seconds = localDate.getSeconds().toString().padStart(2, '0');
 
    // Format the local date-time string
    const localString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
 
    return localString;
 };